import styled from "styled-components";
import { ModalContainer } from "../../../components/Modal/styled";
import { WrapperContainer } from "../../../components";

export const NewDeviceModalContainer = styled(ModalContainer)`
  width: 648px;
`;

export const SectionContentWrapper = styled(WrapperContainer)`
  max-height: 780px;
  height: calc(100vh - 320px);

  width: 100%;

  @media screen and (max-height: 970px) {
    max-height: 780px;
    height: calc(100vh - 320px);
  }
`;

export const PageSelectorWrapper = styled(WrapperContainer)`
  > div {
    border-bottom: unset;
    margin-top: 0;
  }
`;
